import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useRef } from 'react';

import { fixCmsLinks } from '@powdr/utils';

// Render CMS-authored HTML both server-side (so it lands in the static build for
// SEO/no-JS/crawlers) and on the client. 
export const HtmlContentLoader = ({
  html,
  allowRerender = false,
  ...rest
}) => {
  const divRef = useRef(null);
  const isFirstRender = useRef(true);

  const fixedHtml = useMemo(() => (html ? fixCmsLinks(html) : null), [html]);

  useEffect(() => {
    if (!divRef.current) return;
    if (!isFirstRender.current) return;
    isFirstRender.current = Boolean(allowRerender);

    if (!fixedHtml) {
      divRef.current.innerHTML = '';
      return;
    }

    const slotHtml = document
      .createRange()
      .createContextualFragment(fixedHtml);
    divRef.current.innerHTML = '';
    divRef.current.appendChild(slotHtml);
  }, [fixedHtml, divRef, allowRerender]);

  if (!fixedHtml) return null;

  return (
    <div
      {...rest}
      ref={divRef}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: fixedHtml }}
    />
  );
};

HtmlContentLoader.propTypes = {
  html: PropTypes.string.isRequired,
  allowRerender: PropTypes.bool,
};
